<template>
  <div id="nc-container" ref="container"></div>
</template>

<script>
export default {
  props: {
    lang:{
      type: String,
      default: "cn"
    },
    width: {
      type: Number,
      default: 320
    },
    height: {
      type: Number,
      default: 40
    },

  },
  data() {
    return {
      captcha: null,
      captchaButton: null,
      captchaVerifyParam: {},
      SceneId: 'scdzks3d',
      prefix: '36geue',
      upLang: {}
    };
  },
  async mounted() {
    await this.generarte();
    await this.init();
    this.$emit("callbackData", this.callback_data);
  },
  beforeDestroy() {
    if (this.captcha) {
    this.captcha.destroyCaptcha()
      
    }
    // 销毁
  },
  components: {},
  methods: {
    init() {
      this.captchaButton = document.getElementById('submitForm');
      if ( !this.captchaButton ) return
      window.initAliyunCaptcha({
        SceneId: this.SceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: this.prefix, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#nc-container', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: '#submitForm', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        autoRefresh: false, // 设置验证码验证通过后是否自动刷新验证码  //captcha.refresh() 刷新  //captcha.destroyCaptcha()销毁
        immediate: true, //嵌入式下，完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）。
        slideStyle: {
          width: this.width,
          height: this.height,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: this.lang, // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        upLang: this.upLang
      });

    },
    getInstance(instance) {
      this.captcha = instance;
      window.refreshCaptcha = () => {
        if (this.captcha) {
          this.captcha.refresh();
        }
      };

    },
    async captchaVerifyCallback(captchaVerifyParam) {
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      // const result = await xxxx('http://您的业务请求地址', {
      //     captchaVerifyParam: captchaVerifyParam, // 验证码参数
      //     yourBizParam... // 业务参数
      // });
      // return {
      //  captchaResult: true, // 验证码验证是否通过，boolean类型，必选
      //  bizResult: true, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
      // }
      this.captchaVerifyParam = captchaVerifyParam
      return {
        captchaResult: true,
        bizResult: true,
      }
    },
    // 验证通过后调用
    onBizResultCallback(data) {
      const params = {
        captchaVerifyParam: this.captchaVerifyParam,
        sceneId: this.SceneId,
      };
      this.$emit("callbackData", data, params, this.captcha);

    },
    generarte() {

      if (!this.$refs.container) return;
      this.upLang = {
        cn: {
          SLIDE_TIP: '请按住滑块，拖动到最右边',
          SUCCESS: "验证通过",
          _error300:
            '哎呀，出错了，点击<a href="javascript:refreshCaptcha()">刷新</a>再来一次', _errorNetwork:
            '网络不给力，请<a href="javascript:refreshCaptcha()"点击刷新</a>',
        },
        en: {
          SLIDE_TIP: this.$t("newRequirementsAdd.please_drag_to_the_right"),
          SUCCESS: this.$t("newRequirementsAdd.verification_passed"),
          _error300: this.$t(
            "newRequirementsAdd.something_wrong_with_your_network"
          ),
          _errorNetwork: this.$t(
            "newRequirementsAdd.something_wrong_with_your_network"
          ),
        },
      }
    },
  },
};
</script>

<style>
#no-captcha {
  width: 100% !important;
  border-radius: 4px;
}

#aliyunCaptcha-sliding-errorCode{
  display: none !important;
}
#aliyunCaptcha-sliding-wrapper{
  margin-bottom: 0 !important;
}
</style>
